export const NamePill = ({ firstName, lastName }: { firstName: string; lastName: string }) => {
  return (
    <span className={'name-pill purple'}>
      {firstName.toUpperCase().slice(0, 1) + lastName.toUpperCase().slice(0, 1)}
    </span>
  );
};
